import React, { Component } from 'react';

import FormError from 'components/FormError';
import { transformErrorResponse } from 'helpers/errors';

class CheckForOwingLeases extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSent: false,
      error: undefined,
      isOwing: false,
      isTransfered: false,
    };

    this.checkOwing = this.checkOwing.bind(this);
  }

  async checkOwing() {
    const { fetchOwing, fetchOwingAction, sub, transferLease, newSub } =
      this.props;
    const { data } = await fetchOwing(sub.id, 1, { outstanding: true });
    const { results: leases } = data;

    if (!newSub) {
      return;
    }

    if (leases.length > 0) {
      const promises = leases.map((lease) =>
        transferLease(lease.id, newSub.id),
      );

      try {
        const transfers = await Promise.all(promises);
        const statuses = transfers.map((response) => response.status);
        const success = statuses.filter(
          (status) => status === 200 || status === 201,
        );

        if (success.length === promises.length) {
          this.setState({
            isSent: true,
            isTransfered: true,
          });
        }
      } catch ({ response }) {
        const error = transformErrorResponse(response.data);
        this.setState({
          error,
          isSent: false,
        });
      } finally {
        fetchOwingAction(sub.id);
      }
    } else {
      this.setState({
        isOwing: false,
        isSent: true,
      });
    }
  }

  render() {
    const { isSent, error, isOwing, isTransfered } = this.state;
    const { newSub } = this.props;

    return (
      <div className="mar-b">
        <button
          className="btn btn-primary"
          disabled={!newSub}
          onClick={this.checkOwing}
        >
          Check Owing & Transfer
        </button>
        {error ? <FormError error={error} /> : null}
        {!newSub ? (
          <div className="text-danger">
            You must create a new subscription first.
          </div>
        ) : null}
        {isSent && isTransfered ? (
          <div className="text-success">Leases transfered.</div>
        ) : null}
        {!isOwing && isSent && !isTransfered ? (
          <div className="text-success">No owed leases.</div>
        ) : null}
      </div>
    );
  }
}

export default CheckForOwingLeases;
